import React from 'react';
import "../../App.css";

export default function AboutMe() {
    
    return <h1 className="ph-text f-25">Hello, I'm Rachel.
    <div className='wrap'>Curious,</div>Creative<div className='wrap'>& Capable</div><div className='pad-30' /><div className='wrap'><i className=" fa-solid fa-splotch"></i><div className='pad-30' />
    
    </div>I am a designer and developer with 7 years professional web and software experience, here to serve you with all your application needs.<div className='pad-30' /><div className='wrap'><i className=" fa-solid fa-splotch"></i></div>
    
     {/* <div className='pad-30' />I've been blessed with an insatiable yearning to learn and understand many things, and while I have many hobbies and interests, I've found the world wide web is not only a great way to outlet creativity in many ways, but it's also the best place to share experiences, inspiration, and knowlege.<div className='pad-30' /><i className=" fa-solid fa-splotch"></i>
    
    <div className='pad-30' /> If I can share what I've learned and apply my skills and services in ways which help or inspire others, I consider myself blessed beyond measure. */}
    </h1>; 
    
    
}